import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { StructureEditorType } from '@Containers/StructureEditor/constants';
import Marvin from './Marvin';
import Chemdraw from './Chemdraw';

import './StructureEditor.theme.scss';

const editorsMap = {
  [StructureEditorType.MARVIN]: Marvin,
  [StructureEditorType.CHEMDRAW]: Chemdraw,
};

function StructureEditor({ editorType, className, editorInstanceRef, onChange, onLoaded }) {
  const EditorComponent = editorsMap[editorType] || editorsMap[StructureEditorType.MARVIN];

  return (
    <section className={classnames('react-structure-editor', className)}>
      <EditorComponent ref={editorInstanceRef} onChange={onChange} onLoaded={onLoaded} />
    </section>
  );
}

StructureEditor.defaultProps = {
  onChange: () => {},
  onLoaded: () => {},
};

StructureEditor.propTypes = {
  className: PropTypes.string,
  editorInstanceRef: PropTypes.shape({ current: PropTypes.any }),
  editorType: PropTypes.oneOf(StructureEditorType.allTypes),
  onChange: PropTypes.func,
  onLoaded: PropTypes.func,
};

export default StructureEditor;
